import axios from "axios";

const API = `${process.env.REACT_APP_API_URL || "http://localhost:5001"}/api/holidays`;

// endDate defaults to date on the server; employeeIds empty = everyone.
export const createHolidayApi = ({ date, endDate, name, employeeIds, projectId }) =>
  axios.post(API, { date, endDate, name, employeeIds, projectId });

export const deleteHolidayApi = (id) => axios.delete(`${API}/${id}`);
